import React from "react";
import { Container } from "react-bootstrap";

import Logo3 from "../../assets/bisulogo.png";
import Logo4 from "../../assets/logo1.png";
import Logo5 from "../../assets/logo3.png";
import Logo6 from "../../assets/fm.png";

const Footer = () => {
  return (
    <footer
      style={{
        width: "100%",
        minHeight: "150px",
        padding: "14px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        // GLASS
        background:
          "linear-gradient(to bottom, rgba(255,255,255,0.18), rgba(255,255,255,0.08))",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderBottom: "1px solid rgba(255,255,255,0.18)",
        boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
      }}
    >
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            textAlign: "center",
          }}
        >
          {/* Logos */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {[Logo3, Logo4, Logo5, Logo6].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Logo ${index + 1}`}
                style={{ width: "60px", height: "auto" }}
              />
            ))}
          </div>

          {/* Attribution / Collaboration / Instruction */}
          <div
            style={{
              fontSize: "0.85rem",
              lineHeight: 1.35,
              opacity: 0.95,
              maxWidth: "1100px",
            }}
          >
            <div>
              <strong>Developed by:</strong> ᜉᜈᜈᜎᜒᜃᜈ᜔ ᜅ᜔ ᜋᜃᜐ × Full Stack
              Masters, Computing Society, Computer Science Department, Bohol
              Island State University – Bilar Campus 2024-Present
            </div>
            <div>
              <strong>For instruction:</strong> Data Structures and Algorithms;
              Information Management; Complexity of Algorithms; Web Development
              and Enterprises;  Mobile Development; Intelligent Systems
            </div>
            <div>
              <strong>
                M.A.K.A.S.A. Program: BISU–Bilar Research & Extension Platform
              </strong>{" "}
              (
              <a
                href="https://lisa.bisubilar.org/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline" }}
              >
                See LISA module for irrigation dissertation and NIA extension
                details.
              </a>
              )
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
